import React from "react";

export default function Settings() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Settings</h1>
      <p>Update HR system settings, roles, permissions, and preferences here.</p>
      {/* Add forms for settings changes */}
    </div>
  );
}
